"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tracker_1 = require("@openreplay/tracker/cjs");
function default_1() {
    return (app) => {
        if (app === null) {
            return (_1, _2, _3, result) => result;
        }
        return (operationKind, operationName, variables, result) => {
            try {
                app.send(tracker_1.Messages.GraphQL(operationKind, operationName, JSON.stringify(variables), JSON.stringify(result)));
            }
            finally {
                return result;
            }
        };
    };
}
exports.default = default_1;
